import FrontMixins from "../../common/mixins/front-mixins";
export default {
    mixins: [FrontMixins],
    created() {
        this.model = 'Course';
    },
    data(){
        return {
            incomplete:0,
            poll_view:false,
            polls:{},
            table: {headers: [], data: []},
            show_table:false
        }
    },
    methods: {
        startMeeting() {
            this.$api(this.model + '.Host', {id: this.single.id, review: true}, true).then(res => {
                let host_url = res.data.data.host_url;
                //window.open(host_url, '_blank');
                window.location.href = host_url;
                this.view_mode = false;
            });
        },
        mailAttendees() {
            let vm=this;
            this.$api(this.model + '.Mail.Attendee', {id: this.single.id}, true).then(() => {
                vm.$messageBox.success("邮件已经发送给参会者!");
            });
        },
    },
    mounted() {
        window.scrollTo(0,0);
    },

}
